import * as React from "react";
import { useState, useMemo } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import useFeature from "hooks/useFeature";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { Input, Button } from "components/bootstrap";
import { useAddEvidence, useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import { isPermitted } from "util/PermissionsMixin";
import LogsList from "./LogsList";
import { Row, FormGroup } from "../styled.components";
function Logs({ investigation }) {
  const { permissions } = useCurrentUser();
  const [newLogId, setNewLogId] = useState("");
  const [newLogIdx, setNewLogIdx] = useState("");
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteLog, setDeleteLog] = useState(null);
  const isRightSidebarEnabled = useFeature("investigation_right_sidebar");
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted(permissions, "investigations:edit"),
    [investigation.archived, permissions]
  );
  const showAddForm = canManageEvidence && !isRightSidebarEnabled;
  const { addEvidence } = useAddEvidence();
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const isFormValid = useMemo(
    () => newLogId && newLogId.replace(/\s/g, "").length > 0 && newLogIdx && newLogIdx.replace(/\s/g, "").length > 0,
    [newLogId, newLogIdx]
  );
  const onAddLog = async (e) => {
    e.preventDefault();
    if (isFormValid) {
      await addEvidence({
        invId: investigation.id,
        payload: {
          logs: [{ id: newLogId, index: newLogIdx }]
        }
      });
    }
    setNewLogId("");
    setNewLogIdx("");
  };
  const removeLog = async () => {
    await removeEvidence({
      invId: investigation.id,
      payload: {
        logs: [{ id: deleteLog.id, index: deleteLog.index }]
      }
    });
    setShowDeleteDialog(false);
    setDeleteLog(null);
  };
  const onDelete = (log) => (e) => {
    e.stopPropagation();
    setShowDeleteDialog(true);
    setDeleteLog(log);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteLog(null);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showAddForm && /* @__PURE__ */ React.createElement("form", { onSubmit: onAddLog }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "add-log-id",
      type: "text",
      label: "Add Log",
      "data-testid": "add-log-id",
      autoComplete: "off",
      placeholder: "Enter Log ID",
      value: newLogId,
      onChange: (e) => setNewLogId(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "add-log-idx",
      type: "text",
      "data-testid": "add-log-idx",
      autoComplete: "off",
      placeholder: "Enter Log Index",
      value: newLogIdx,
      onChange: (e) => setNewLogIdx(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", onClick: onAddLog, disabled: !isFormValid }, "Add"))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    LogsList,
    {
      investigation,
      canManageEvidence,
      onDelete
    }
  )), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: "Delete Log",
      onConfirm: removeLog,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    "Are you sure you want to delete this Log?"
  ));
}
export default Logs;
